import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Tenant } from '../../../../Models/tenant';
import { ModuleRecordFeedMappableEntityDto } from '../Models/FeedConfigurationModels/ModuleRecordFeedMappableEntityDto';
import { IFeedConfiguration } from './IFeedConfiguration';
import { ILocationLevel } from './ILocationLevel';

@Injectable({
    providedIn: 'root'
})
export class FeedService {
    private apiUrl = '/api/feed/';
    private apiMappableEntitiesUrl = 'api/mappable-entities/';
    private apiLocationLevelsUrl = 'api/location-levels';

    constructor(private http: HttpClient) { }

    public getFeedConfigurations(tenantName: string) {
        const url = `${this.apiUrl}getfeedconfigurations?tenantName=${tenantName}`;
        return this.http.get<IFeedConfiguration[]>(url);
    }

    public getFeedConfigurationsFromName(tenantName: string, feedname: string) {
        const url = `${this.apiUrl}getfeedconfigurations?tenantName=${tenantName}&feedname=${feedname}`;
        return this.http.get<IFeedConfiguration[]>(url);
    }

    public getFeedConfigurationsFromPath(tenantName: string, sftpPath: string, filePattern: string) {
        const url = `${this.apiUrl}getfeedconfigurations?tenantName=${tenantName}&sftpPath=${sftpPath}&filePattern=${filePattern}`;
        return this.http.get<IFeedConfiguration[]>(url);
    }

    public getFeedConfigurationsWithoutDataFields(tenantName: string) {
        const url = `${this.apiUrl}getfeedconfigurationswithoutdatafields?tenantName=${tenantName}`;
        return this.http.get<IFeedConfiguration[]>(url);
    }

    public getSSOFeedConfigurations(tenantName: string): Observable<IFeedConfiguration[]> {
        const url = `${this.apiUrl}get-sso-feeds?tenantName=${tenantName}`;
        return this.http.get<IFeedConfiguration[]>(url);
    }

    public getMappableEntities(tenant: Tenant, moduleId: string, version: number, moduleStatusId: number): Observable<ModuleRecordFeedMappableEntityDto[]> {
        return this.http.get<ModuleRecordFeedMappableEntityDto[]>(`${this.apiMappableEntitiesUrl}?tenantId=${tenant.TenantId}&moduleId=${moduleId}&version=${version}&moduleStatusId=${moduleStatusId}`);
    }

    public getFeedConfiguration(tenantName: string, feedConfigurationId: string) {
        if (feedConfigurationId === '00000000-0000-0000-0000-000000000000') {
            return of(this.getNewFeedConfiguration());
        }

        const url = `${this.apiUrl}getfeedconfiguration?tenantName=${tenantName}&feedConfigurationId=${feedConfigurationId}`;
        return this.http.get<IFeedConfiguration>(url);
    }

    public getNewFeedConfiguration(): IFeedConfiguration {
        return {
            Id: '00000000-0000-0000-0000-000000000000',
            Name: null,
            CreatedBy: '00000000-0000-0000-0000-000000000000',
            CreatedOn: new Date(),
            UpdatedBy: null,
            UpdatedOn: null,
            MarkedAsDeletedBy: null,
            MarkedAsDeletedOn: null,
            MarkedAsDeleted: false,
            Description: null,
            SftpLocation: null,
            FilePattern: '*.csv',
            Enabled: true,
            BulkAddUpdateEnabled: false,
            DataFields: [],
            FeedType: null,
            SSOFeed: false,
            SSOAvaIdentifier: '',
            EmailOnSuccess: false,
            EmailAddress: '',
            Threshold: 0,
            AlreadySyncedLists: [],
            ModuleId: null,
            FormFlowId: null,
            FileNameRegex: null,
            AllowRecordsForDeactivatedSites: true,
            DisableClientNotifications: false
        };
    }

    public getLocationLevels(tenantName: string) {
        const url = `${this.apiLocationLevelsUrl}?tenantName=${tenantName}`;
        return this.http.get<ILocationLevel[]>(url);
    }

    public saveFeedConfiguration(tenantName: string, config: IFeedConfiguration) {
        const url = `${this.apiUrl}savefeedconfiguration?tenantName=${tenantName}`;
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        const options = { headers: headers };
        return this.http.post<string>(url, config, options);
    }

    public setFeedConfigurationEnabled(tenantName: string, feedConfigurationId: string, enabled: boolean) {
        const url = `${this.apiUrl}setfeedconfigurationenabled?tenantName=${tenantName}&feedConfigurationId=${feedConfigurationId}&enabled=${enabled}`;
        return this.http.put<any>(url, null);
    }

    public deleteFeedConfiguration(tenantName: string, feedConfigurationId: string) {
        const url = `${this.apiUrl}deletefeedconfiguration?tenantName=${tenantName}&feedConfigurationId=${feedConfigurationId}`;
        return this.http.delete(url);
    }
}
